import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../header/images/logo.png';
import './menuoff.css';

const MenuOff = () => {
  return (
    <header className="menuoff">
      <div className="menuoff__logo">
        <Link to="/">
          <img src={logo} alt="ContaLearn" className="menuoff__logo-img" />
        </Link>
      </div>

      <nav className="menuoff__links" aria-label="Primary">
        <NavLink to="/login" className="none-decoration">
          <div className="menuoff__conectare">
            <span className="color-menu-off">Conecteaza-te</span>
          </div>
        </NavLink>

        <NavLink to="/registrer" className="none-decoration">
          <div className="create-cont">
            <span className="color-menu-off">Creaza cont</span>
          </div>
        </NavLink>
      </nav>

      <div className="menuoff__mobile-start">
        <NavLink to="/login" className="none-decoration">
          <div className="menuoff__starty">
            <span>start</span>
          </div>
        </NavLink>
      </div>
    </header>
  );
};

export default MenuOff;
